module.exports = __webpack_public_path__ + "img/pours.abded5ba.jpg";